import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "app-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertComponent = _resolveComponent("AlertComponent")!
  const _component_LoadingOverlay = _resolveComponent("LoadingOverlay")!
  const _component_LoginComponent = _resolveComponent("LoginComponent")!
  const _component_MenuComponent = _resolveComponent("MenuComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_AlertComponent),
    _createVNode(_component_LoadingOverlay),
    (!_ctx.isAuthenticated)
      ? (_openBlock(), _createBlock(_component_LoginComponent, {
          key: 0,
          login: _ctx.handleLogin
        }, null, 8, ["login"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_MenuComponent, {
            isCollapsed: _ctx.isCollapsed,
            configMenu: _ctx.configMenu,
            username: _ctx.username,
            onToggleSidebar: _ctx.toggleSidebar,
            onChangeView: _cache[0] || (_cache[0] = ($event: any) => (_ctx.currentView = $event)),
            onLogout: _ctx.logout
          }, null, 8, ["isCollapsed", "configMenu", "username", "onToggleSidebar", "onLogout"]),
          (_openBlock(), _createBlock(_KeepAlive, {
            class: "main-content",
            style: _normalizeStyle(_ctx.styleObject)
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentView), {
              onChangeView: _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentView = $event))
            }, null, 32))
          ], 1032, ["style"]))
        ]))
  ]))
}